import { render } from "./CommonButtonSecondary.vue?vue&type=template&id=16987716&scoped=true"
import script from "./CommonButtonSecondary.vue?vue&type=script&lang=js"
export * from "./CommonButtonSecondary.vue?vue&type=script&lang=js"

import "./CommonButtonSecondary.vue?vue&type=style&index=0&id=16987716&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16987716"]])

export default __exports__